import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const OpportunityNoteListDetails = () => {
  const columns = [
    { label: 'Note', value: 'content' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];
  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/opportunity/note/details/' + encodedId;
  };
  return <ListTemplate fetchUrl={API_DOMAIN + API_ROUTES['opportunityNotes']} columns={columns} onAccessDetails={handleAccessDetails} />;
};

export default OpportunityNoteListDetails;